// @flow

//
// React
//
import React from 'react';

//
// Type
//
import {
    type CellRendererFactoryProps,
    type CellProps,
} from '../types/CellProps';

//
// Formatter
//
import { fmtQuantity } from '../../../../trix-web-data-commons';

//
// Helper
//
import { renderAsLink } from './tools';

//
// Component
//
const createQuantityCellRenderer = (cfg: CellRendererFactoryProps): any => (props: CellProps): any => {
    return (
        <div>
            {renderAsLink(cfg.onClick, props.row)(fmtQuantity(props.value))}
        </div>
    );
};
export default createQuantityCellRenderer;
